
/**
 * Created by kongwm.kong on 2017/7/27.
 */

import axios from 'axios';
import qs from 'querystring';
import router from '../routes/index';
import store from '../vuex/store';
axios.defaults.withCredentials = true;  //自动带cookie
axios.defaults.baseURL = '/v1';  //全局url加v1
// axios.defaults.timeout = 5000; //超时处理

// console.log(axios.interceptors);
// 添加一个请求拦截器
axios.interceptors.request.use(function (config) {
    // console.log(config);
    // console.log(config.transformRequest);
    // Do something before request is sent
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
     if(typeof response.data.message === 'string' && response.data.message.indexOf('未登录') >-1){
         store.state.isLogin = false;
         store.state.userData = null;
         router.push('/login');
    }else if(response.data.code ===400){
         console.log(response.data)
         store.state.msg = response.data.message;
    } else if(response.data.code ===500){
         console.log(response.data)
        if(typeof response.data.message === 'string' && response.data.message.indexOf('承诺函') >-1 ){

        } else {
            // router.push('/500');
        }
    }
    return response;
}, function (error) {
    // router.push('/500');
    return Promise.reject(error);
});


export default {
    get(api, params, successCallback, errorCallback) {
        axios.get(api, {
            params: params
        })
        .then(successCallback)
        .catch(errorCallback);
    },
    post(api, params, successCallback, errorCallback) {
        axios.post(api, qs.stringify(params)).then(successCallback).catch(errorCallback);
    },
    request(params, successCallback, errorCallback){
        // console.log('params.url: '+ params.url);
        axios(params).then(successCallback).catch(errorCallback);
    }
}



// WEBPACK FOOTER //
// ./src/util/http.js